<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M16 4c.51 0 .923.413.923.923v7.126l5.5-1.375c.4-.1.82.078 1.025.437l4.43 7.754a.92.92 0 01.122.458 5.354 5.354 0 01-10.708 0c0-.16.042-.318.122-.458l3.357-5.876-10.011 2.503 3.826 6.696a.92.92 0 01.122.458 5.354 5.354 0 01-10.708 0c0-.16.042-.318.122-.458l4.43-7.754a.923.923 0 01.578-.437l5.947-1.487V4.923c0-.51.413-.923.923-.923zM9.354 16.753l2.84 4.97h-5.68l2.84-4.97zm13.292-3.323l-2.84 4.97h5.68l-2.84-4.97z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsBalanceFilled'
}
</script>
